import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import TextArea from 'antd/es/input/TextArea';
import Select, { StylesConfig } from "react-select";
import { useCreateContactMutation, useGetAllAccountsQuery, useGetAllContactsQuery, useGetContactByIdQuery, useGetContactLookupQuery, useLazyGetContactByIdQuery, useLazyGetLocationQuery, useUpdateContactMutation, useUploadProfilePictureMutation } from "../../../services/EndPointsApis";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../Features/authslice";
import TextField from '../../../core/common/textFields/TextField';
import { InputMask } from '@react-input/mask';
import { removeImage, setImage } from '../../../Features/commonSlice';
import { RootState } from '../../../store';
import Ribbon from '../../../core/common/ribbon/ribbon';
import { customStyles } from '../../../core/common/Custom Style/CustomStyle';
import { debounce } from 'lodash';
import axios from 'axios';
import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import { inputMaskNumber } from '../../../core/common/textFields/NumberField';


const AddContacts = () => {
    const location = useLocation();
    const contactId = useParams();
    const isEditing = location.pathname.includes('EditContacts')
    const viewOnly = location.pathname.includes('ViewContacts')
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [searchStr, setSearchStr] = useState('');
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [imgPath, setimgPath] = useState('')
    const [updateId, setUpdateId] = useState(0);
    const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('perferredTime', formattedTime);
    };
    const contactSchema = Yup.object().shape({
        contactType: Yup.object({
            id: Yup.number().min(1, 'Contact Type must be selected').required('Contact Type Id is required'),
            name: Yup.string().required('Contact Type is required')
        }).required(),
        contactStatus: Yup.object({
            id: Yup.number().min(1, 'Contact Status must be selected').required('Contact Status Id is required'),
            name: Yup.string().required('Contact Status is required')
        }).required(),
        // lst_Account: Yup.object({
        //     id: Yup.string().min(1, 'Account must be selected').required('Account Id is required'),
        //     value: Yup.string().required('Account is required')
        // }).required(),
        firstName: Yup.string().required("First Name is required"),
        salutation: Yup.object({
            id: Yup.number().min(1, 'Salutation Id must be selected').required('Salutation Id is required'),
            name: Yup.string().required('Salutation is required')
        }).required(),
        lastName: Yup.string().required("Last Name is required"),
    });

    const initialValues = {
        contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        accountId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        contactNo: '',
        organizationId: 0,
        firstName: '',
        lastName: '',
        email: '',
        imageUrl: '',
        note: '',
        updatedBy: "",
        createdDT: "2024-09-11T12:04:49.777Z",
        updatedDT: "2024-09-11T12:04:49.777Z",
        companyName: '',
        homePhone: '',
        workPhone: '',
        cellPhone: '',
        fax: '',
        isActive: true,
        homeEmail: '',
        perferredTime: '2024-09-11T12:04:49.777Z',
        sourceDescription: '',
        isSubNewsLetter: false,
        isPrimaryContact: true,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zipCode: '',
        country: {
            id: 0,
            title: ''
        },
        contactType: {
            id: 0,
            name: ''
        },
        contactStatus: {
            id: 0,
            name: ''
        },
        salutation: {
            id: 0,
            name: ''
        },
        maritalStatus: {
            id: 0,
            name: ''
        },
        genderType: {
            id: 0,
            name: ''
        },
        inquiryMethod: {
            id: 0,
            name: ''
        },
        leadSource: {
            id: 0,
            name: ''
        },
        preferredMethod: {
            id: 0,
            name: ''
        },
        lst_Account: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ''
        },
        addressAs: '',
        propertyAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        },
        mailingAddress: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            contactId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            addressLine1: "",
            addressLine2: "",
            zipCode: "",
            stateId: 0,
            stateName: "",
            cityId: 0,
            cityName: "",
            chooseCityId: 0,
            chooseCityName: "",
            addressTypeId: 0,
            addressTypeName: ""
        }
    };

    //Location Api 
    const [triggerLocation, { data: locationData }] = useLazyGetLocationQuery();

    //Api's

    const [createContact, { data, isError, error, isSuccess, isLoading }] =
        useCreateContactMutation();

    const [UpdateContact, { data: updatedata, isError: updateIsError, error: updateError, isSuccess: updateIsSuccess, isLoading: updateIsLoading }] =
        useUpdateContactMutation();

    const { data: getContactLookup, refetch } = useGetContactLookupQuery('');
    // const { data: getContactbyId, refetch:getContactRefetch } = useGetContactByIdQuery({contactId:contactId?.id});
    const [TriggerContactbyId, { data: getContactbyId }] = useLazyGetContactByIdQuery()

    const [uploadPhoto, { data: uploadPhotoData }] = useUploadProfilePictureMutation();

    const contactData = useSelector((state: any) => state?.common?.selectedContactData);

    const { data: allAccounts, refetch: allAccountsRefetch } = useGetAllAccountsQuery('');

    const initialValuesImage = {
        file: ""
    }

    //upload Image
    const formikImageUpload = useFormik({
        initialValues: initialValuesImage,
        onSubmit: (values) => {
            uploadPhoto({ ...values });
        }
    });
    //Api's
    const formik = useFormik({
        initialValues,
        validationSchema: contactSchema,
        onSubmit: (values) => {
            if (isEditing) {
                UpdateContact({ ...values })
            } else {
                createContact({ ...values });
            }
        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (getContactbyId?.result && Object.keys(getContactbyId?.result).length > 0) {
            setUpdateId(getContactbyId?.result?.contactId);
            formik.setValues({ ...getContactbyId?.result });
        } else {
            setUpdateId(0);
        }
    }, [getContactbyId, updateId]);

    const handleContactType = (selectedOption: any) => {
        formik.setFieldValue(' inquiryMethod', selectedOption);
    };
    const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const imageUrl = URL.createObjectURL(file);
        dispatch(setImage(imageUrl));

        // Set Formik values for local preview
        formik.setFieldValue('imageUrl', imageUrl);
        formik.setFieldValue('file', file);

        // Prepare FormData
        const formData = new FormData();
        formData.append('file', file);
        console.log(formData, 'formData');
        try {
            // Send the image via axios
            const response = await axios.post(
                'https://afdapidev.azurewebsites.net/api/Account/UploadProfilePicture',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Important for file uploads
                    },
                }
            );

            console.log('Upload successful:', response.data); // Check response data

            // Update state and Formik with the server response
            setimgPath(response.data.result); // Assuming response.data.result contains the image path
            dispatch(setImage(response.data.result)); // Update the redux state with the image URL
            formik.setFieldValue('imageUrl', response.data.result); // Set Formik field with the image URL
        } catch (error) {
            console.error('Error uploading the image:', error);
        }
    };

    const handleRemoveImage = () => {
        dispatch(removeImage());
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            resetForm();
            navigate('/contacts')
        }
        if (updateIsSuccess) {
            toast.success(updatedata?.message);
            navigate('/contacts')

        }

    }, [isSuccess, updateIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
        if (updateIsError && updateError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in updateError && updateError.data && typeof updateError.data === 'object' && 'message' in updateError.data) {
                errorMessage = (updateError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error, updateIsError, updateError]);
    const handleBack = () => {
        navigate('/Contacts')
    }
    const items = [
        {
            tooltipLabel: 'Back',
            icon: svgIcons.BackIcon,
            onClick: () => handleBack(),
        },
    ];
    useEffect(() => {
        if (isEditing || viewOnly) {
            TriggerContactbyId({ contactId: contactId?.id })
        }
    }, [TriggerContactbyId])


    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value);
        delayedSearch(value);
        formik.setFieldValue("mailingAddress.zipCode", value)
    }
    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLocation({ ZipCode: searchValue })
        }, 1000),
        []
    );


    useEffect(() => {
        if (locationData && locationData?.result && locationData?.result?.state !== null && locationData?.result?.city !== null) {
            formik.setFieldValue("mailingAddress.stateName", locationData?.result?.state || '')
            formik.setFieldValue("mailingAddress.cityName", locationData?.result?.city || '')
        } else {
            formik.setFieldValue("mailingAddress.stateName", '');
            formik.setFieldValue("mailingAddress.cityName", '');
        }
    }, [locationData]);


    return (
        <div className="page-wrapper">
            <div className="content">
                <form onSubmit={formik.handleSubmit} >

                    <div className="row">
                        <div className="col-md-12">
                            <Ribbon
                                items={items}
                                ribbonHeading={isEditing ? 'Update Contact' : viewOnly ? 'View Contact' : 'New Contact'}
                                buttonText={isEditing
                                    ? (updateIsLoading ? 'Please wait...' : 'Update')
                                    : (viewOnly
                                        ? ''
                                        : (isLoading
                                            ? 'Please wait...'
                                            : 'Save'
                                        )
                                    )}
                                buttonClass="add-popup ribbon-btn "
                            // onClickbtn={formik.handleSubmit}
                            />
                            <div className="row" style={{ height: '765px', overflow: 'auto' }}>
                                <div className="col-md-4">
                                    <div className="card ">
                                        <div className="card-body p-3">
                                            <h5 className='mb-2'>
                                                Contact Person
                                            </h5>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="profile-pic-upload">
                                                        <div className="profile-pic">
                                                            <span className="position-absolute top-0 start-100 translate-middle pointer" onClick={handleRemoveImage}>
                                                                {svgIcons.DeleteIcon}
                                                            </span>
                                                            <img
                                                                src={formik.values?.imageUrl || '/assets/img/profiles/default-upload-img.svg'}
                                                                alt="img"
                                                                className="preview1"
                                                            />
                                                        </div>
                                                        <div className="upload-content">
                                                            <div className="upload-btn">
                                                                <input
                                                                    type="file"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    onChange={handleImageChange}
                                                                    ref={fileInputRef}
                                                                />
                                                                <span>
                                                                    <i className="ti ti-upload" />
                                                                    Upload Image
                                                                </span>
                                                            </div>
                                                            <p>JPG, GIF or PNG. Max size of 800K</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Type{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactType?.id
                                                                    ? {
                                                                        value: formik.values?.contactType?.id,
                                                                        label: formik.values?.contactType?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly || (isEditing && formik.values?.contactType?.id === 17)}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactType.id', selectedOption.value);
                                                                formik.setFieldValue('contactType.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactType && formik.errors.contactType && (
                                                        <>
                                                            <div className="error">{formik.errors.contactType.id}</div>
                                                        </>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Status{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactStatus?.id
                                                                    ? {
                                                                        value: formik.values?.contactStatus?.id,
                                                                        label: formik.values?.contactStatus?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactStatus.id', selectedOption.value);
                                                                formik.setFieldValue('contactStatus.name', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactStatus && formik.errors.contactStatus && (
                                                        <div className="error">{formik.errors.contactStatus?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Account{" "}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={allAccounts?.result?.data?.map((option: any) => ({
                                                                label: option?.accountName,
                                                                value: option?.accountId
                                                            }))}
                                                            value={
                                                                formik.values?.lst_Account?.id
                                                                    ? {
                                                                        value: formik.values?.lst_Account?.id,
                                                                        label: formik.values?.lst_Account?.value || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('lst_Account.id', selectedOption.value);
                                                                formik.setFieldValue('lst_Account.value', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.lst_Account && formik.errors.lst_Account && (
                                                        <div className="error">{formik.errors.lst_Account?.value}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Company Name"
                                                            type="text"
                                                            {...formik.getFieldProps("companyName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Salutation{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.salutation?.id
                                                                    ? {
                                                                        value: formik.values?.salutation?.id,
                                                                        label: formik.values?.salutation?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('salutation.id', selectedOption.value);
                                                                formik.setFieldValue('salutation.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.salutation?.id && formik.errors.salutation?.id && (
                                                        <div className="error">{formik.errors.salutation?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label=" First Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("firstName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.firstName && formik.errors.firstName && (
                                                        <div className="error">{formik.errors.firstName}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Last Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("lastName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.lastName && formik.errors.lastName && (
                                                        <div className="error">{formik.errors.lastName}</div>
                                                    )}
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address As"
                                                            type="text"
                                                            {...formik.getFieldProps("addressAs")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Marital Status</label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.maritalStatus?.id
                                                                    ? {
                                                                        value: formik.values?.maritalStatus?.id,
                                                                        label: formik.values?.maritalStatus?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('maritalStatus.id', selectedOption.value);
                                                                formik.setFieldValue('maritalStatus.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-md-12 d-flex align-items-center">
                                                    <div className="radio-wrap">
                                                        <label className="input-label">Status</label>
                                                        <div className="d-flex flex-wrap">
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="active"
                                                                    name="active"
                                                                    value="true"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.active === true}
                                                                    onChange={() => formik.setFieldValue('active', true)}
                                                                />
                                                                <label htmlFor="active">Active</label>
                                                            </div>
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="inactive"
                                                                    name="active"
                                                                    value="false"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.active === false}
                                                                    onChange={() => formik.setFieldValue('active', false)}
                                                                />
                                                                <label htmlFor="inactive">Inactive</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="card-body p-3">
                                            <h5 className='mb-2'>Contact Info</h5>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Home Phone
                                                        </label>
                                                        <InputMask mask={inputMaskNumber}
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("homePhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Work Phone
                                                        </label>
                                                        <InputMask mask={inputMaskNumber}
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("workPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Cell Phone
                                                        </label>
                                                        <InputMask mask={inputMaskNumber}
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("cellPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Fax
                                                        </label>
                                                        <InputMask mask={inputMaskNumber}
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("fax")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Home Email"
                                                            type="email"
                                                            {...formik.getFieldProps("homeEmail")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Work Email "
                                                            type="email"
                                                            {...formik.getFieldProps("email")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Preferred Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.preferredMethod?.id
                                                                    ? {
                                                                        value: formik.values?.preferredMethod?.id,
                                                                        label: formik.values?.preferredMethod?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('preferredMethod.id', selectedOption.value);
                                                                formik.setFieldValue('preferredMethod.name', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="input-label">
                                                        Preferred Times
                                                    </label>
                                                    <TimePicker
                                                        placeholder="Select Time"
                                                        className="form-control datetimepicker-time"
                                                        // {...formik.getFieldProps('freshAptTime')}
                                                        onChange={onChangeStart}
                                                        // defaultOpenValue={dayjs("00:00 AM", "h:mm A")}
                                                        format="h:mm A"
                                                        use12Hours
                                                        // Check if startTime exists and is a valid format before passing it to dayjs
                                                        value={formik.values?.perferredTime && dayjs(formik.values.perferredTime, "h:mm A").isValid()
                                                            ? dayjs(formik.values?.perferredTime, "h:mm A")
                                                            : null}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="radio-wrap">
                                                        <label className="input-label">Status</label>
                                                        <div className="d-flex flex-wrap">
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="active"
                                                                    name="active"
                                                                    value="true"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.isActive === true}
                                                                    onChange={() => formik.setFieldValue('isActive', true)}
                                                                />
                                                                <label htmlFor="active">Active</label>
                                                            </div>
                                                            <div className="radio-btn">
                                                                <input
                                                                    type="radio"
                                                                    className="status-radio"
                                                                    id="inactive"
                                                                    name="active"
                                                                    value="false"
                                                                    disabled={viewOnly}
                                                                    checked={formik.values.isActive === false}
                                                                    onChange={() => formik.setFieldValue('isActive', false)}
                                                                />
                                                                <label htmlFor="inactive">Inactive</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="input-label">
                                                        Unsubscribe from Newsletter?<span className="text-danger"> *</span>
                                                    </label>
                                                    <label className="checkboxs mt-2 mb-5">
                                                        <input
                                                            type="checkbox"
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card">
                                        <div className="card-body p-3">
                                            <h5 className='mb-2'>Mailing Address</h5>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 1"
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.addressLine1")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 2 "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.addressLine2")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="ZipCode "
                                                            type="text"
                                                            value={immediateSearchStr || formik.values?.mailingAddress?.zipCode}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="City "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.cityName")}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="State/Region "
                                                            type="text"
                                                            {...formik.getFieldProps("mailingAddress.stateName")}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='card-body card-css'>
                                            <h5>Contact Source Info</h5>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Inquiry Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.inquiryMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.inquiryMethod?.id
                                                                    ? {
                                                                        value: formik.values?.inquiryMethod?.id,
                                                                        label: formik.values?.inquiryMethod?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('inquiryMethod.id', selectedOption.value);
                                                                formik.setFieldValue('inquiryMethod.name', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Lead Source </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.leadSourceType?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.leadSource?.id
                                                                    ? {
                                                                        value: formik.values?.leadSource?.id,
                                                                        label: formik.values?.leadSource?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('leadSource.id', selectedOption.value);
                                                                formik.setFieldValue('leadSource.name', selectedOption.label);
                                                            }}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label ">Source Description
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <TextArea
                                                            className="form-control height-150"
                                                            defaultValue="21213"
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("sourceDescription")}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AddContacts